import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import _ from 'lodash';
import { AnexoContratoResponse, FirmasFaltante } from 'src/app/global/interfaces/anexo-contrato-response';
import { DatosPersonales } from 'src/app/global/interfaces/datos-personales';
import { Nacionalidad } from 'src/app/global/interfaces/nacionalidad';
import { Paso3 } from 'src/app/global/interfaces/paso-3';
import { ACTIONS } from 'src/app/global/models/dialog/dialog-data';
import { DialogDataThree } from 'src/app/global/models/dialog/dialog-data-three';
import { CuentaAbonoSubject } from 'src/app/global/services/cuenta-abono-subject.service';
import { DatosSociosService } from 'src/app/global/services/datos-socios.service';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { ValidacionCIPreFirmaVM } from 'src/app/view-model/providers/services/validacion-ci-prefirma/validacion-ci-prefirma.provider';
import { AnexoContratoServiceVM } from 'src/app/view-model/services/anexo-contrato.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { PayProcessServiceVM } from 'src/app/view-model/services/pay-process.service';

@Component({
  selector: 'app-firmar-documentos',
  templateUrl: './firmar-documentos.component.html',
  styleUrls: ['./firmar-documentos.component.scss']
})
export class FirmarDocumentosComponent implements OnInit, AfterViewInit {

  public infoAnexosContrato: AnexoContratoResponse;
  public firmasFaltantes: Array<FirmasFaltante>;
  public cargandoAnexos: boolean = false;
  public showFirmar: boolean;
  public showDocumentLetter: boolean = false;
  public firmarDoc: boolean = false;
  public runFirmador: number = null;
  public listSignersStore: Array<FirmasFaltante>;
  public listSignersView: Array<FirmasFaltante> = [];
  public isAceptaTerminos: boolean = false;
  public loadingButton: boolean = false;
  public storePaso3: Paso3;
  public screenSize: number;
  isPersonaNatural: boolean = this.localStorageService.getPaso1Login().currentIsPersonaNatural;
  listaRepresentantes: DatosPersonales[];

  @HostListener('window:resize', ['$event'])
  cambiaAnchura() {
    this.screenSize = window.innerWidth
  }

  constructor(
    private anexoContratoService: AnexoContratoServiceVM,
    private cuentaAbonoSubject: CuentaAbonoSubject,
    private dialogService: DialogService,
    private anexoContratoServiceVM: AnexoContratoServiceVM,
    private localStorageService: LocalStorageService,
    private payProcessServiceVM: PayProcessServiceVM,
    private datosSociosService: DatosSociosService,
    private validaCi:ValidacionCIPreFirmaVM,
    
  ) {
    localStorage.removeItem('modal')
    this.cuentaAbonoSubject.subAnexoContrato$.subscribe((response) => {
      this.showFirmar = response;
    });
  }

  async ngOnInit() {
    this.screenSize = window.innerWidth;
    this.storePaso3 = this.localStorageService.getPaso3();

    if (!this.isPersonaNatural && this.storePaso3.validaPaso3.data) {
      this.obtienesRepresentantes();
    }

    if (!this.storePaso3.validaPaso3.data) {
      await this.generarAnexoContrato();
    } else {
      this.cargandoAnexos = true;
      this.showDocumentLetter = true;
    }
  }

  ngAfterViewInit() {
    if (this.storePaso3.errorFirma && !localStorage.getItem('modal')) {
      if(this.isPersonaNatural) {
        this.modalDisenfg(this.storePaso3.errorFirma);
      } else {
        this.modalDisenfgRRLL(this.storePaso3.errorFirma);
      }
    }
  }

  async obtienesRepresentantes() {
    const fnSuccess = async (resp) => {
      if (resp != null) {
        this.listaRepresentantes = resp as DatosPersonales[];
        if (((this.listSignersStore == undefined || this.listSignersStore == null) && (this.firmasFaltantes == undefined || this.firmasFaltantes == null)) 
        || (this.listSignersStore.length === 0 && this.firmasFaltantes.length === 0)) {
          this.listaRepresentantes.forEach(representante => {
            let data: FirmasFaltante = {
              nombre: representante.nombre.nombres + ' ' + representante.nombre.apellidoPaterno + ' ' + representante.nombre.apellidoMaterno,
              nacionalidad: this.getNombrePais(representante.idNacionalidad),
              rut: Number(representante.run),
              estado: 'SIN_APROBAR', // default
              status: false // default
            }
            this.listSignersView.push(data);
          });
          this.firmarDoc = false;
        }
      }
    };

    const fnFailure = (error) => {
      console.error(error);
    };

    this.datosSociosService.getSociosRegistrados().subscribe(fnSuccess, fnFailure);
  }

  private async generarAnexoContrato() {
    const cbOK = response => {
      this.infoAnexosContrato = response;
      let store = this.localStorageService.getPaso3();
      this.listSignersStore = (store.lstFirmadores) ? store.lstFirmadores : [];
      this.firmasFaltantes = response.data.firmasFaltantes;
      if (this.listSignersStore.length !== 0 && this.firmasFaltantes.length !== 0) {
        let listFirma = [];
        this.firmasFaltantes.forEach(firmanteService => {
          let firmante = this.listSignersStore.filter(firmanteStore => firmanteStore.rut != firmanteService.rut);
          listFirma.push(firmante)
        });
        //let oneLevel: Array<FirmasFaltante> = listFirma[0];
        //this.listSignersView = [...this.firmasFaltantes, ...oneLevel];
        this.listSignersView = this.firmasFaltantes;
      } else if (this.listSignersStore.length !== 0 && this.firmasFaltantes.length === 0) {
        this.listSignersView = [...this.listSignersStore];
      } else if (this.listSignersStore.length === 0 && this.firmasFaltantes.length === 0) {
        const data: FirmasFaltante = {
          nombre: this.storePaso3.persona.nombre.nombres + ' ' + this.storePaso3.persona.nombre.apellidoPaterno + ' ' + this.storePaso3.persona.nombre.apellidoMaterno,
          nacionalidad: this.getNombrePais(this.storePaso3.persona.idNacionalidad),
          rut: Number(this.storePaso3.persona.run),
          estado: 'SIN_APROBAR',
          status: false // default
        }
        this.listSignersView.push(data);
      } else {
        this.listSignersView = [...response.data.firmasFaltantes, ...this.listSignersStore];
      }

      this.cargandoAnexos = true;
      this.showDocumentLetter = true;
      this.isAceptaTerminos = response.data.firmado;
      this.firmarDoc = false;
    };

    const cbError = error => {
      console.error('Error Anexo contrato: ', error);
    };

    this.anexoContratoService.getAnexoContrato().subscribe(cbOK, cbError);
  }

  private getNombrePais(idNacionalidad: number): string {
    const pais: Nacionalidad = _.find(this.storePaso3.nacionalidades, { id: idNacionalidad });
    return pais.nombre;
  }

  private modalDisenfg(dataThreeDialog: DialogDataThree) {
    const responseDialog = this.dialogService.openDialogThreeInfoComponent(dataThreeDialog);
    responseDialog.afterOpened().subscribe(resp => console.log('Se levanto Modal', resp));
    responseDialog.afterClosed().subscribe(resp => {
      if (resp.action === ACTIONS.OK) {
        this.firmarDocumento();
      }
    });
    localStorage.setItem('modal', 'ok');
  }

  private modalDisenfgRRLL(dataThreeDialog: DialogDataThree) {
    const data = {
      title: dataThreeDialog.title,
      description: dataThreeDialog.description,
      actionButton: 'Cerrar',
      icon: null
    };
    this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe(() => {
      return;
    });
    localStorage.setItem('modal', 'ok');
  }

  private modalError() {
    const data = {
      title: 'Discúlpanos, algo ha salido mal.',
      description: 'En este momento no hemos podido procesar tus respuestas; puedes intentarlo en las próximas horas, ingresando nuevamente más tarde.',
      actionButton: 'Cerrar',
      icon: null
    };
    this.dialogService.openOneActionDialog({ data }).afterClosed().subscribe(() => {
      return;
    });
    localStorage.setItem('modal', 'ok');
  }

  private async preViewDoc() {
    return await this.anexoContratoService.getPreviewDocumento().toPromise();
  }

  public async preView(document) {
    this.cambioEstadoLinkDoc(document);
    if (this.screenSize >=960) {
      let dialogRef = this.dialogService.openPdfViewer(await this.preViewDoc());
  
      dialogRef.afterClosed().subscribe((resp: any) => {
        if (resp.action === 'OK') {
          this.cambioEstadoLinkDoc(document);
        }
      });
    } else {
      this.pdfMobile();
    }

  }

  private async pdfMobile() {
    const docURL = await this.anexoContratoService.getPreviewDocumento().toPromise();
    let byteCharacters = atob(docURL);
    let byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    let byteArray = new Uint8Array(byteNumbers);
    let file = new Blob([byteArray], { type: 'application/pdf;base64'});
    const pdfURL = (window.URL || window['webkitURL']).createObjectURL(file);
    const anchorElement = document.createElement('a');
    anchorElement.href = pdfURL;
    anchorElement.target = '_blank';
    anchorElement.download = 'Preview_Contrato.pdf';
    anchorElement.click();
    this.showDocumentLetter = true;
  }

  private cambioEstadoLinkDoc(document) {
    if (document === 'carta') {
      this.showDocumentLetter = !this.showDocumentLetter;
    }
  }

  public async firmarDocumento() {
    try {
      this.firmarDoc = true;
      let stepThree = this.localStorageService.getPaso3();
      this.infoAnexosContrato = await this.anexoContratoService.getAnexoContrato().toPromise();
      this.firmasFaltantes = this.infoAnexosContrato.data.firmasFaltantes;
      this.runFirmador = +stepThree.persona.run;
      const bodyApruebaDoc = {
        runRepresentante: this.runFirmador,
        tipoDocumento: this.infoAnexosContrato.data.tipoDocumento,
        tipoAprobacion: 'FIRMA_ELECTRONICA'
      };

      let responseFirma = await this.anexoContratoServiceVM.postApruebaDocumento(bodyApruebaDoc).toPromise();
      let firmante = this.firmasFaltantes.find(fF => fF.rut === this.runFirmador);
      let sThree = this.localStorageService.getPaso3();
      // let lstFrimantes = (sThree.lstFirmadores) ? sThree.lstFirmadores : []
      sThree.firmador = firmante;
      sThree.lstFirmadores = [...this.firmasFaltantes];
      this.localStorageService.setPaso3(sThree);
      window.location.href = responseFirma.data;
    } catch (error) {
      console.error(`error`, error);
      const contenido = _.get(error,'error.mensaje.contenido','');
      const estadoValidacionCI = await this.validaCi.assertCedulaIdentidadVigente(contenido,this.runFirmador);                 
      if(estadoValidacionCI ==='VALIDADO'){
            await this.firmarDocumento();
            return;
        }
      this.modalError();
      this.firmarDoc = false;
    }
  }

  public async firmarDocumentoRRLL(run : number) {
    try {
      this.firmarDoc = true;
      this.infoAnexosContrato = await this.anexoContratoService.getAnexoContrato().toPromise();
      this.firmasFaltantes = this.infoAnexosContrato.data.firmasFaltantes;
      this.runFirmador = run;
      const bodyApruebaDoc = {
        runRepresentante: this.runFirmador,
        tipoDocumento: this.infoAnexosContrato.data.tipoDocumento,
        tipoAprobacion: 'FIRMA_ELECTRONICA'
      };

      let responseFirma = await this.anexoContratoServiceVM.postApruebaDocumento(bodyApruebaDoc).toPromise();
      let firmante = this.firmasFaltantes.find(fF => fF.rut === this.runFirmador);
      let sThree = this.localStorageService.getPaso3();
      sThree.firmador = firmante;
      sThree.lstFirmadores = [...this.firmasFaltantes];
      this.localStorageService.setPaso3(sThree);
      window.location.href = responseFirma.data;
    } catch (error) {
      console.error(`error`, error);
      const contenido = _.get(error,'error.mensaje.contenido','');
      const estadoValidacionCI = await this.validaCi.assertCedulaIdentidadVigente(contenido,run);                 
      if(estadoValidacionCI ==='VALIDADO'){
            await this.firmarDocumentoRRLL(run);//.catch(ee=>{throw ee});
            return;
        }
      
      this.modalError();
      this.firmarDoc = false;
    }
  }

  public async continuarPaso3() {
    this.loadingButton = true;
    let dataPaso3 = this.localStorageService.getPaso3();
    dataPaso3.anexoContrato = this.infoAnexosContrato;
    this.localStorageService.setPaso3(dataPaso3);
    const response = await this.payProcessServiceVM.payProcess(false);
    if (response === 'AGENDAR_FECHA') {
      this.loadingButton = false;
      console.error('Error en la fecha seleccionada');
      this.dialogService.openFechaVencida();
    }
  }

}
